"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Abstraction of Material UI's `TextField`
 */
class TextField extends _react.default.PureComponent {
  /**
   * Value changed.
   *
   * @param {Event} e
   * @return {void}
   */
  handleChange = e => {
    this.props.onChange(e.target.value || null, this.props.name);
  };
  /**
   * Render.
   * 
   * @return {ReactNode}
   */

  render() {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextField.default, { ...this.props.TextFieldProps,
      autoComplete: this.props.autoComplete,
      autoFocus: this.props.autoFocus,
      className: this.props.className,
      color: this.props.color,
      disabled: this.props.disabled,
      error: this.props.error,
      fullWidth: this.props.fullWidth,
      helperText: this.props.error && this.props.errorText || this.props.helperText,
      inputProps: this.inputProps,
      inputRef: this.props.inputRef,
      InputProps: this.props.InputProps,
      InputLabelProps: this.InputLabelProps,
      label: this.props.label,
      multiline: this.props.multiline,
      onBlur: this.props.onBlur,
      onChange: this.handleChange,
      onFocus: this.props.onFocus,
      placeholder: this.props.placeholder || (this.props.placeholderLabel ? this.props.label : undefined),
      required: this.props.required,
      rows: this.props.rows,
      rowsMax: this.props.rowsMax,
      size: this.props.size,
      style: this.props.style,
      type: this.props.type,
      value: this.props.value || "",
      variant: this.props.variant
    });
  }
  /**
   * Get our `pattern` attribute value
   *
   * We apply a default pattern when we're a `number` input 
   * restricting the input to only digit characters.
   * 
   * @return {String|undefined}
   */


  get pattern() {
    if (this.props.pattern) return this.props.pattern;else if (this.props.type === "number") return "^[0-9]+$";else return undefined;
  }
  /**
   * Get our `inputProps`.
   * 
   * @return {Object}
   */


  get inputProps() {
    return { ...this.props.inputProps,
      maxLength: this.props.maxLength,
      minLength: this.props.minLength,
      max: this.props.max,
      min: this.props.type === "number" && isNaN(this.props.min) ? 0 : this.props.min,
      pattern: this.pattern
    };
  }
  /**
   * Get our `InputLabelProps`.
   * 
   * @return {Object}
   */


  get InputLabelProps() {
    return { ...this.props.InputLabelProps,
      shrink: this.props.shrink || this.props.placeholder || this.props.placeholderLabel ? true : undefined
    };
  }

  static propTypes = {
    InputProps: _propTypes.default.object,
    InputLabelProps: _propTypes.default.object,
    TextFieldProps: _propTypes.default.object,
    autoComplete: _propTypes.default.bool,
    autoFocus: _propTypes.default.bool,
    className: _propTypes.default.string,
    color: _propTypes.default.oneOf(["primary", "secondary"]),
    disabled: _propTypes.default.bool,
    error: _propTypes.default.bool,
    errorText: _propTypes.default.string,
    fullWidth: _propTypes.default.bool,
    helperText: _propTypes.default.string,
    inputProps: _propTypes.default.object,
    inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.shape({
      current: _propTypes.default.instanceOf(Element)
    })]),
    label: _propTypes.default.string,
    max: _propTypes.default.number,
    maxLength: _propTypes.default.number,
    min: _propTypes.default.number,
    minLength: _propTypes.default.number,
    multiline: _propTypes.default.bool,
    name: _propTypes.default.string,
    onBlur: _propTypes.default.func,
    onChange: _propTypes.default.func,
    onFocus: _propTypes.default.func,
    pattern: _propTypes.default.string,
    placeholder: _propTypes.default.string,
    placeholderLabel: _propTypes.default.bool,
    required: _propTypes.default.bool,
    rows: _propTypes.default.number,
    rowsMax: _propTypes.default.number,
    shrink: _propTypes.default.bool,
    size: _propTypes.default.oneOf(["small", "medium"]),
    style: _propTypes.default.object,
    type: _propTypes.default.string,
    value: _propTypes.default.string,
    variant: _propTypes.default.oneOf(["standard", "outlined", "filled"])
  };
  static defaultProps = {
    color: "primary",
    size: "small",
    variant: "outlined"
  };
}

var _default = TextField;
exports.default = _default;